/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * ZonHub
 * Project management for Solar
 * OpenAPI spec version: 1.0.0
 */
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query"
import { useMutation, useQuery } from "@tanstack/react-query"

import type {
	ApiSchemaRetrieve200Four,
	ApiSchemaRetrieve200One,
	ApiSchemaRetrieve200Three,
	ApiSchemaRetrieve200Two,
	ApiSchemaRetrieveParams,
	ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	ApiV1InvestmentSessionRetrieve200,
	ApiV1InvestorIbanPartialUpdate200,
	ApiV1InvestorIbanPartialUpdate400,
	ApiV1PaymentOwnerVerificationRetrieveParams,
	ApiV1PaymentSupplierVerificationRetrieveParams,
	ApiV1ProfilePhonePartialUpdate200,
	ApiV1ProfilePhonePartialUpdate400,
	BackupCodeResponse,
	ChangePrimaryMethod,
	CodeLogin,
	CodeResponse,
	ConfigResponse,
	EndexPrice,
	EndexProgressGlobal,
	EndexProgressProject,
	EndexTariff,
	FooterResponse,
	LivePerformance,
	Login,
	LoginCodeResponse,
	LoginResponse,
	MFAMethodCode,
	MFAMethodDeactivationValidator,
	OwnerVerification,
	OwnerVerificationResponse,
	PaginatedNavigationItemTypeList,
	PatchedIban,
	PatchedUserPhone,
	ProductionFactor,
	RequestMFAMethodActivationConfirm,
	RequestMFAMethodBackupCodesRegeneration,
	SupplierVerification,
	SupplierVerificationResponse,
	UserMFAMethod,
	UserProfile,
	VerificationPayment,
} from ".././@types"

import { api, apiWithTokenAuth } from "../../api"

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
	(<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
	[P in keyof T]-?: IfEquals<
		{ [Q in P]: T[P] },
		{ -readonly [Q in P]: T[P] },
		P
	>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
	k: infer I,
) => void
	? I
	: never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
	? {
			[P in keyof Writable<T>]: T[P] extends object
				? NonReadonly<NonNullable<T[P]>>
				: T[P]
		}
	: DistributeReadOnlyOverUnions<T>

export const apiAuthActivateCreate = (method: string, signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/auth/${method}/activate/`,
		method: "POST",
		signal,
	})
}

export const getApiAuthActivateCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthActivateCreate>>,
		TError,
		{ method: string },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthActivateCreate>>,
	TError,
	{ method: string },
	TContext
> => {
	const mutationKey = ["apiAuthActivateCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthActivateCreate>>,
		{ method: string }
	> = (props) => {
		const { method } = props ?? {}

		return apiAuthActivateCreate(method)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthActivateCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthActivateCreate>>
>

export type ApiAuthActivateCreateMutationError = unknown

export const useApiAuthActivateCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthActivateCreate>>,
		TError,
		{ method: string },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthActivateCreate>>,
	TError,
	{ method: string },
	TContext
> => {
	const mutationOptions = getApiAuthActivateCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthActivateConfirmCreate = (
	method: string,
	requestMFAMethodActivationConfirm: RequestMFAMethodActivationConfirm,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<BackupCodeResponse>({
		url: `/api/auth/${method}/activate/confirm/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: requestMFAMethodActivationConfirm,
		signal,
	})
}

export const getApiAuthActivateConfirmCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthActivateConfirmCreate>>,
		TError,
		{ method: string; data: RequestMFAMethodActivationConfirm },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthActivateConfirmCreate>>,
	TError,
	{ method: string; data: RequestMFAMethodActivationConfirm },
	TContext
> => {
	const mutationKey = ["apiAuthActivateConfirmCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthActivateConfirmCreate>>,
		{ method: string; data: RequestMFAMethodActivationConfirm }
	> = (props) => {
		const { method, data } = props ?? {}

		return apiAuthActivateConfirmCreate(method, data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthActivateConfirmCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthActivateConfirmCreate>>
>
export type ApiAuthActivateConfirmCreateMutationBody =
	RequestMFAMethodActivationConfirm
export type ApiAuthActivateConfirmCreateMutationError = unknown

export const useApiAuthActivateConfirmCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthActivateConfirmCreate>>,
		TError,
		{ method: string; data: RequestMFAMethodActivationConfirm },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthActivateConfirmCreate>>,
	TError,
	{ method: string; data: RequestMFAMethodActivationConfirm },
	TContext
> => {
	const mutationOptions =
		getApiAuthActivateConfirmCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthCodesRegenerateCreate = (
	method: string,
	requestMFAMethodBackupCodesRegeneration: RequestMFAMethodBackupCodesRegeneration,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<BackupCodeResponse>({
		url: `/api/auth/${method}/codes/regenerate/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: requestMFAMethodBackupCodesRegeneration,
		signal,
	})
}

export const getApiAuthCodesRegenerateCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthCodesRegenerateCreate>>,
		TError,
		{ method: string; data: RequestMFAMethodBackupCodesRegeneration },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthCodesRegenerateCreate>>,
	TError,
	{ method: string; data: RequestMFAMethodBackupCodesRegeneration },
	TContext
> => {
	const mutationKey = ["apiAuthCodesRegenerateCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthCodesRegenerateCreate>>,
		{ method: string; data: RequestMFAMethodBackupCodesRegeneration }
	> = (props) => {
		const { method, data } = props ?? {}

		return apiAuthCodesRegenerateCreate(method, data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthCodesRegenerateCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthCodesRegenerateCreate>>
>
export type ApiAuthCodesRegenerateCreateMutationBody =
	RequestMFAMethodBackupCodesRegeneration
export type ApiAuthCodesRegenerateCreateMutationError = unknown

export const useApiAuthCodesRegenerateCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthCodesRegenerateCreate>>,
		TError,
		{ method: string; data: RequestMFAMethodBackupCodesRegeneration },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthCodesRegenerateCreate>>,
	TError,
	{ method: string; data: RequestMFAMethodBackupCodesRegeneration },
	TContext
> => {
	const mutationOptions =
		getApiAuthCodesRegenerateCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthDeactivateCreate = (
	method: string,
	mFAMethodDeactivationValidator: MFAMethodDeactivationValidator,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<void>({
		url: `/api/auth/${method}/deactivate/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: mFAMethodDeactivationValidator,
		signal,
	})
}

export const getApiAuthDeactivateCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthDeactivateCreate>>,
		TError,
		{ method: string; data: MFAMethodDeactivationValidator },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthDeactivateCreate>>,
	TError,
	{ method: string; data: MFAMethodDeactivationValidator },
	TContext
> => {
	const mutationKey = ["apiAuthDeactivateCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthDeactivateCreate>>,
		{ method: string; data: MFAMethodDeactivationValidator }
	> = (props) => {
		const { method, data } = props ?? {}

		return apiAuthDeactivateCreate(method, data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthDeactivateCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthDeactivateCreate>>
>
export type ApiAuthDeactivateCreateMutationBody = MFAMethodDeactivationValidator
export type ApiAuthDeactivateCreateMutationError = unknown

export const useApiAuthDeactivateCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthDeactivateCreate>>,
		TError,
		{ method: string; data: MFAMethodDeactivationValidator },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthDeactivateCreate>>,
	TError,
	{ method: string; data: MFAMethodDeactivationValidator },
	TContext
> => {
	const mutationOptions = getApiAuthDeactivateCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthCodeRequestCreate = (
	mFAMethodCode: MFAMethodCode,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<CodeResponse>({
		url: `/api/auth/code/request/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: mFAMethodCode,
		signal,
	})
}

export const getApiAuthCodeRequestCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthCodeRequestCreate>>,
		TError,
		{ data: MFAMethodCode },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthCodeRequestCreate>>,
	TError,
	{ data: MFAMethodCode },
	TContext
> => {
	const mutationKey = ["apiAuthCodeRequestCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthCodeRequestCreate>>,
		{ data: MFAMethodCode }
	> = (props) => {
		const { data } = props ?? {}

		return apiAuthCodeRequestCreate(data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthCodeRequestCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthCodeRequestCreate>>
>
export type ApiAuthCodeRequestCreateMutationBody = MFAMethodCode
export type ApiAuthCodeRequestCreateMutationError = unknown

export const useApiAuthCodeRequestCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthCodeRequestCreate>>,
		TError,
		{ data: MFAMethodCode },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthCodeRequestCreate>>,
	TError,
	{ data: MFAMethodCode },
	TContext
> => {
	const mutationOptions = getApiAuthCodeRequestCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthLoginCreate = (login: Login, signal?: AbortSignal) => {
	return api<LoginResponse>({
		url: `/api/auth/login/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: login,
		signal,
	})
}

export const getApiAuthLoginCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthLoginCreate>>,
		TError,
		{ data: Login },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthLoginCreate>>,
	TError,
	{ data: Login },
	TContext
> => {
	const mutationKey = ["apiAuthLoginCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthLoginCreate>>,
		{ data: Login }
	> = (props) => {
		const { data } = props ?? {}

		return apiAuthLoginCreate(data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthLoginCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthLoginCreate>>
>
export type ApiAuthLoginCreateMutationBody = Login
export type ApiAuthLoginCreateMutationError = unknown

export const useApiAuthLoginCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthLoginCreate>>,
		TError,
		{ data: Login },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthLoginCreate>>,
	TError,
	{ data: Login },
	TContext
> => {
	const mutationOptions = getApiAuthLoginCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthLoginCodeCreate = (
	codeLogin: CodeLogin,
	signal?: AbortSignal,
) => {
	return api<LoginCodeResponse>({
		url: `/api/auth/login/code/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: codeLogin,
		signal,
	})
}

export const getApiAuthLoginCodeCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthLoginCodeCreate>>,
		TError,
		{ data: CodeLogin },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthLoginCodeCreate>>,
	TError,
	{ data: CodeLogin },
	TContext
> => {
	const mutationKey = ["apiAuthLoginCodeCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthLoginCodeCreate>>,
		{ data: CodeLogin }
	> = (props) => {
		const { data } = props ?? {}

		return apiAuthLoginCodeCreate(data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthLoginCodeCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthLoginCodeCreate>>
>
export type ApiAuthLoginCodeCreateMutationBody = CodeLogin
export type ApiAuthLoginCodeCreateMutationError = unknown

export const useApiAuthLoginCodeCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthLoginCodeCreate>>,
		TError,
		{ data: CodeLogin },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthLoginCodeCreate>>,
	TError,
	{ data: CodeLogin },
	TContext
> => {
	const mutationOptions = getApiAuthLoginCodeCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthLogoutCreate = (signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/auth/logout/`,
		method: "POST",
		signal,
	})
}

export const getApiAuthLogoutCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthLogoutCreate>>,
		TError,
		void,
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthLogoutCreate>>,
	TError,
	void,
	TContext
> => {
	const mutationKey = ["apiAuthLogoutCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthLogoutCreate>>,
		void
	> = () => {
		return apiAuthLogoutCreate()
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthLogoutCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthLogoutCreate>>
>

export type ApiAuthLogoutCreateMutationError = unknown

export const useApiAuthLogoutCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthLogoutCreate>>,
		TError,
		void,
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthLogoutCreate>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions = getApiAuthLogoutCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthMfaChangePrimaryMethodCreate = (
	changePrimaryMethod: ChangePrimaryMethod,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<void>({
		url: `/api/auth/mfa/change-primary-method/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: changePrimaryMethod,
		signal,
	})
}

export const getApiAuthMfaChangePrimaryMethodCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthMfaChangePrimaryMethodCreate>>,
		TError,
		{ data: ChangePrimaryMethod },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiAuthMfaChangePrimaryMethodCreate>>,
	TError,
	{ data: ChangePrimaryMethod },
	TContext
> => {
	const mutationKey = ["apiAuthMfaChangePrimaryMethodCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiAuthMfaChangePrimaryMethodCreate>>,
		{ data: ChangePrimaryMethod }
	> = (props) => {
		const { data } = props ?? {}

		return apiAuthMfaChangePrimaryMethodCreate(data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiAuthMfaChangePrimaryMethodCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthMfaChangePrimaryMethodCreate>>
>
export type ApiAuthMfaChangePrimaryMethodCreateMutationBody =
	ChangePrimaryMethod
export type ApiAuthMfaChangePrimaryMethodCreateMutationError = unknown

export const useApiAuthMfaChangePrimaryMethodCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiAuthMfaChangePrimaryMethodCreate>>,
		TError,
		{ data: ChangePrimaryMethod },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiAuthMfaChangePrimaryMethodCreate>>,
	TError,
	{ data: ChangePrimaryMethod },
	TContext
> => {
	const mutationOptions =
		getApiAuthMfaChangePrimaryMethodCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiAuthMfaConfigRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<ConfigResponse>({
		url: `/api/auth/mfa/config/`,
		method: "GET",
		signal,
	})
}

export const getApiAuthMfaConfigRetrieveQueryKey = () => {
	return [`/api/auth/mfa/config/`] as const
}

export const getApiAuthMfaConfigRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiAuthMfaConfigRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>
	> = ({ signal }) => apiAuthMfaConfigRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAuthMfaConfigRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>
>
export type ApiAuthMfaConfigRetrieveQueryError = unknown

export function useApiAuthMfaConfigRetrieve<
	TData = Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiAuthMfaConfigRetrieve<
	TData = Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiAuthMfaConfigRetrieve<
	TData = Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiAuthMfaConfigRetrieve<
	TData = Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaConfigRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiAuthMfaConfigRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

export const apiAuthMfaUserActiveMethodsList = (signal?: AbortSignal) => {
	return apiWithTokenAuth<UserMFAMethod[]>({
		url: `/api/auth/mfa/user-active-methods/`,
		method: "GET",
		signal,
	})
}

export const getApiAuthMfaUserActiveMethodsListQueryKey = () => {
	return [`/api/auth/mfa/user-active-methods/`] as const
}

export const getApiAuthMfaUserActiveMethodsListQueryOptions = <
	TData = Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiAuthMfaUserActiveMethodsListQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>
	> = ({ signal }) => apiAuthMfaUserActiveMethodsList(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAuthMfaUserActiveMethodsListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>
>
export type ApiAuthMfaUserActiveMethodsListQueryError = unknown

export function useApiAuthMfaUserActiveMethodsList<
	TData = Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
				TError,
				Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiAuthMfaUserActiveMethodsList<
	TData = Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
				TError,
				Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiAuthMfaUserActiveMethodsList<
	TData = Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiAuthMfaUserActiveMethodsList<
	TData = Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiAuthMfaUserActiveMethodsList>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiAuthMfaUserActiveMethodsListQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

export const apiCmsFooterRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<FooterResponse>({
		url: `/api/cms/footer/`,
		method: "GET",
		signal,
	})
}

export const getApiCmsFooterRetrieveQueryKey = () => {
	return [`/api/cms/footer/`] as const
}

export const getApiCmsFooterRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiCmsFooterRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
	> = ({ signal }) => apiCmsFooterRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsFooterRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
>
export type ApiCmsFooterRetrieveQueryError = unknown

export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsFooterRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

export const apiCmsFooterRetrieve2 = (id: number, signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/cms/footer/${id}/`,
		method: "GET",
		signal,
	})
}

export const getApiCmsFooterRetrieve2QueryKey = (id: number) => {
	return [`/api/cms/footer/${id}/`] as const
}

export const getApiCmsFooterRetrieve2QueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsFooterRetrieve2QueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
	> = ({ signal }) => apiCmsFooterRetrieve2(id, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsFooterRetrieve2QueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
>
export type ApiCmsFooterRetrieve2QueryError = unknown

export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsFooterRetrieve2QueryOptions(id, options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

export const apiCmsFooterFindRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/cms/footer/find/`,
		method: "GET",
		signal,
	})
}

export const getApiCmsFooterFindRetrieveQueryKey = () => {
	return [`/api/cms/footer/find/`] as const
}

export const getApiCmsFooterFindRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsFooterFindRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
	> = ({ signal }) => apiCmsFooterFindRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsFooterFindRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
>
export type ApiCmsFooterFindRetrieveQueryError = unknown

export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsFooterFindRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

export const apiCmsNavigationList = (signal?: AbortSignal) => {
	return apiWithTokenAuth<PaginatedNavigationItemTypeList>({
		url: `/api/cms/navigation/`,
		method: "GET",
		signal,
	})
}

export const getApiCmsNavigationListQueryKey = () => {
	return [`/api/cms/navigation/`] as const
}

export const getApiCmsNavigationListQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationList>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiCmsNavigationListQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsNavigationList>>
	> = ({ signal }) => apiCmsNavigationList(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsNavigationList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsNavigationListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsNavigationList>>
>
export type ApiCmsNavigationListQueryError = unknown

export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationList>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsNavigationList>>,
				TError,
				Awaited<ReturnType<typeof apiCmsNavigationList>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationList>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsNavigationList>>,
				TError,
				Awaited<ReturnType<typeof apiCmsNavigationList>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationList>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationList>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsNavigationListQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

export const apiCmsNavigationRetrieve = (id: number, signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/cms/navigation/${id}/`,
		method: "GET",
		signal,
	})
}

export const getApiCmsNavigationRetrieveQueryKey = (id: number) => {
	return [`/api/cms/navigation/${id}/`] as const
}

export const getApiCmsNavigationRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsNavigationRetrieveQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
	> = ({ signal }) => apiCmsNavigationRetrieve(id, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsNavigationRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
>
export type ApiCmsNavigationRetrieveQueryError = unknown

export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsNavigationRetrieveQueryOptions(id, options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

export const apiCmsNavigationFindRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/cms/navigation/find/`,
		method: "GET",
		signal,
	})
}

export const getApiCmsNavigationFindRetrieveQueryKey = () => {
	return [`/api/cms/navigation/find/`] as const
}

export const getApiCmsNavigationFindRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsNavigationFindRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
	> = ({ signal }) => apiCmsNavigationFindRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsNavigationFindRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
>
export type ApiCmsNavigationFindRetrieveQueryError = unknown

export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsNavigationFindRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.

- YAML: application/vnd.oai.openapi
- JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = (
	params?: ApiSchemaRetrieveParams,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<
		| ApiSchemaRetrieve200One
		| ApiSchemaRetrieve200Two
		| ApiSchemaRetrieve200Three
		| ApiSchemaRetrieve200Four
	>({ url: `/api/schema/`, method: "GET", params, signal })
}

export const getApiSchemaRetrieveQueryKey = (
	params?: ApiSchemaRetrieveParams,
) => {
	return [`/api/schema/`, ...(params ? [params] : [])] as const
}

export const getApiSchemaRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiSchemaRetrieveQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiSchemaRetrieve>>
	> = ({ signal }) => apiSchemaRetrieve(params, signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiSchemaRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSchemaRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiSchemaRetrieve>>
>
export type ApiSchemaRetrieveQueryError = unknown

export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params: undefined | ApiSchemaRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiSchemaRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiSchemaRetrieve>>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiSchemaRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiSchemaRetrieve>>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiSchemaRetrieveQueryOptions(params, options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * API view with client details: their sensors, panels and home type.

Note that this includes sensor tokens, so this is sensitive information.
 */
export const apiV1ClientRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/v1/client/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ClientRetrieveQueryKey = () => {
	return [`/api/v1/client/`] as const
}

export const getApiV1ClientRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiV1ClientRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ClientRetrieve>>
	> = ({ signal }) => apiV1ClientRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ClientRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ClientRetrieve>>
>
export type ApiV1ClientRetrieveQueryError = unknown

export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ClientRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * API view that shows all endex tariffs for a certain date range
 */
export const apiV1ComparisonEndexProgressGlobalRetrieve = (
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<EndexProgressGlobal>({
		url: `/api/v1/comparison/endex-progress-global/`,
		method: "GET",
		params,
		signal,
	})
}

export const getApiV1ComparisonEndexProgressGlobalRetrieveQueryKey = (
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
) => {
	return [
		`/api/v1/comparison/endex-progress-global/`,
		...(params ? [params] : []),
	] as const
}

export const getApiV1ComparisonEndexProgressGlobalRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonEndexProgressGlobalRetrieveQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>>
	> = ({ signal }) =>
		apiV1ComparisonEndexProgressGlobalRetrieve(params, signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonEndexProgressGlobalRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>>
>
export type ApiV1ComparisonEndexProgressGlobalRetrieveQueryError = unknown

export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonEndexProgressGlobalRetrieveQueryOptions(
			params,
			options,
		)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * An API view for returning current Endex price
 */
export const apiV1ComparisonProjectEndexPriceRetrieve = (
	id: number,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<EndexPrice>({
		url: `/api/v1/comparison/project/${id}/endex-price/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ComparisonProjectEndexPriceRetrieveQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/endex-price/`] as const
}

export const getApiV1ComparisonProjectEndexPriceRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectEndexPriceRetrieveQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>>
	> = ({ signal }) => apiV1ComparisonProjectEndexPriceRetrieve(id, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectEndexPriceRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>>
>
export type ApiV1ComparisonProjectEndexPriceRetrieveQueryError = unknown

export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectEndexPriceRetrieveQueryOptions(id, options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * API view that shows all endex tariffs for a specific project's interestperiods
 */
export const apiV1ComparisonProjectEndexProgressRetrieve = (
	id: number,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<EndexProgressProject>({
		url: `/api/v1/comparison/project/${id}/endex-progress/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ComparisonProjectEndexProgressRetrieveQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/endex-progress/`] as const
}

export const getApiV1ComparisonProjectEndexProgressRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectEndexProgressRetrieveQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>>
	> = ({ signal }) => apiV1ComparisonProjectEndexProgressRetrieve(id, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectEndexProgressRetrieveQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>>
	>
export type ApiV1ComparisonProjectEndexProgressRetrieveQueryError = unknown

export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectEndexProgressRetrieveQueryOptions(id, options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * API view that shows all endex tariffs for a specific project's interestperiods
 */
export const apiV1ComparisonProjectEndexTariffsList = (
	id: number,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<EndexTariff[]>({
		url: `/api/v1/comparison/project/${id}/endex-tariffs/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ComparisonProjectEndexTariffsListQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/endex-tariffs/`] as const
}

export const getApiV1ComparisonProjectEndexTariffsListQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectEndexTariffsListQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>
	> = ({ signal }) => apiV1ComparisonProjectEndexTariffsList(id, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectEndexTariffsListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>
>
export type ApiV1ComparisonProjectEndexTariffsListQueryError = unknown

export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ComparisonProjectEndexTariffsListQueryOptions(
		id,
		options,
	)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * API view for getting data for live performance graph.
 */
export const apiV1ComparisonProjectLivePerformanceList = (
	id: number,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<LivePerformance[]>({
		url: `/api/v1/comparison/project/${id}/live-performance/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ComparisonProjectLivePerformanceListQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/live-performance/`] as const
}

export const getApiV1ComparisonProjectLivePerformanceListQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectLivePerformanceListQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>>
	> = ({ signal }) => apiV1ComparisonProjectLivePerformanceList(id, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectLivePerformanceListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>>
>
export type ApiV1ComparisonProjectLivePerformanceListQueryError = unknown

export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectLivePerformanceListQueryOptions(id, options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * API view for getting data for production factor table.
 */
export const apiV1ComparisonProjectProductionFactorList = (
	id: number,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<ProductionFactor[]>({
		url: `/api/v1/comparison/project/${id}/production-factor/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ComparisonProjectProductionFactorListQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/production-factor/`] as const
}

export const getApiV1ComparisonProjectProductionFactorListQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectProductionFactorListQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectProductionFactorList>>
	> = ({ signal }) => apiV1ComparisonProjectProductionFactorList(id, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectProductionFactorList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectProductionFactorListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectProductionFactorList>>
>
export type ApiV1ComparisonProjectProductionFactorListQueryError = unknown

export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectProductionFactorListQueryOptions(id, options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * API endpoint to fetch details about the investment thats stored in the session.
Requires authentication.
 */
export const apiV1InvestmentSessionRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<ApiV1InvestmentSessionRetrieve200>({
		url: `/api/v1/investment/session/`,
		method: "GET",
		signal,
	})
}

export const getApiV1InvestmentSessionRetrieveQueryKey = () => {
	return [`/api/v1/investment/session/`] as const
}

export const getApiV1InvestmentSessionRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiV1InvestmentSessionRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
	> = ({ signal }) => apiV1InvestmentSessionRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1InvestmentSessionRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
>
export type ApiV1InvestmentSessionRetrieveQueryError = unknown

export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1InvestmentSessionRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * Update IBAN for the authenticated user.
 */
export const apiV1InvestorIbanPartialUpdate = (
	patchedIban: NonReadonly<PatchedIban>,
) => {
	return apiWithTokenAuth<ApiV1InvestorIbanPartialUpdate200>({
		url: `/api/v1/investor/iban/`,
		method: "PATCH",
		headers: { "Content-Type": "application/json" },
		data: patchedIban,
	})
}

export const getApiV1InvestorIbanPartialUpdateMutationOptions = <
	TError = ApiV1InvestorIbanPartialUpdate400,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
		TError,
		{ data: NonReadonly<PatchedIban> },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
	TError,
	{ data: NonReadonly<PatchedIban> },
	TContext
> => {
	const mutationKey = ["apiV1InvestorIbanPartialUpdate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
		{ data: NonReadonly<PatchedIban> }
	> = (props) => {
		const { data } = props ?? {}

		return apiV1InvestorIbanPartialUpdate(data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1InvestorIbanPartialUpdateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>
>
export type ApiV1InvestorIbanPartialUpdateMutationBody =
	NonReadonly<PatchedIban>
export type ApiV1InvestorIbanPartialUpdateMutationError =
	ApiV1InvestorIbanPartialUpdate400

export const useApiV1InvestorIbanPartialUpdate = <
	TError = ApiV1InvestorIbanPartialUpdate400,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
		TError,
		{ data: NonReadonly<PatchedIban> },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
	TError,
	{ data: NonReadonly<PatchedIban> },
	TContext
> => {
	const mutationOptions =
		getApiV1InvestorIbanPartialUpdateMutationOptions(options)

	return useMutation(mutationOptions)
}
/**
 * API view for the timestamp of the last KACO measurement in the DB.

Used for automatic monitoring of insertion progress.
 */
export const apiV1MeasurementKacoLastTimestampRetrieve = (
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<void>({
		url: `/api/v1/measurement/kaco/last_timestamp/`,
		method: "GET",
		signal,
	})
}

export const getApiV1MeasurementKacoLastTimestampRetrieveQueryKey = () => {
	return [`/api/v1/measurement/kaco/last_timestamp/`] as const
}

export const getApiV1MeasurementKacoLastTimestampRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
			>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1MeasurementKacoLastTimestampRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>>
	> = ({ signal }) => apiV1MeasurementKacoLastTimestampRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1MeasurementKacoLastTimestampRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>>
>
export type ApiV1MeasurementKacoLastTimestampRetrieveQueryError = unknown

export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
			>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>,
				TError,
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
			>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>,
				TError,
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
			>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
			>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1MeasurementKacoLastTimestampRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * A method to get all clients and their related data for ProjectOwner confirmation
 */
export const apiV1PaymentOwnerVerificationRetrieve = (
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<VerificationPayment>({
		url: `/api/v1/payment/${id}/owner-verification/`,
		method: "GET",
		params,
		signal,
	})
}

export const getApiV1PaymentOwnerVerificationRetrieveQueryKey = (
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
) => {
	return [
		`/api/v1/payment/${id}/owner-verification/`,
		...(params ? [params] : []),
	] as const
}

export const getApiV1PaymentOwnerVerificationRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1PaymentOwnerVerificationRetrieveQueryKey(id, params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>
	> = ({ signal }) =>
		apiV1PaymentOwnerVerificationRetrieve(id, params, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1PaymentOwnerVerificationRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>
>
export type ApiV1PaymentOwnerVerificationRetrieveQueryError = unknown

export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params: undefined | ApiV1PaymentOwnerVerificationRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>,
					TError,
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>,
					TError,
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1PaymentOwnerVerificationRetrieveQueryOptions(
		id,
		params,
		options,
	)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * A method to accept the payment for the ProjectOwner
 */
export const apiV1PaymentOwnerVerificationCreate = (
	id: number,
	ownerVerification: OwnerVerification,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<OwnerVerificationResponse>({
		url: `/api/v1/payment/${id}/owner-verification/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: ownerVerification,
		signal,
	})
}

export const getApiV1PaymentOwnerVerificationCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
		TError,
		{ id: number; data: OwnerVerification },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
	TError,
	{ id: number; data: OwnerVerification },
	TContext
> => {
	const mutationKey = ["apiV1PaymentOwnerVerificationCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
		{ id: number; data: OwnerVerification }
	> = (props) => {
		const { id, data } = props ?? {}

		return apiV1PaymentOwnerVerificationCreate(id, data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1PaymentOwnerVerificationCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>
>
export type ApiV1PaymentOwnerVerificationCreateMutationBody = OwnerVerification
export type ApiV1PaymentOwnerVerificationCreateMutationError = unknown

export const useApiV1PaymentOwnerVerificationCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
		TError,
		{ id: number; data: OwnerVerification },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
	TError,
	{ id: number; data: OwnerVerification },
	TContext
> => {
	const mutationOptions =
		getApiV1PaymentOwnerVerificationCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
/**
 * A method to get all clients and their related data for ProjectOwner confirmation
 */
export const apiV1PaymentSupplierVerificationRetrieve = (
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<VerificationPayment>({
		url: `/api/v1/payment/${id}/supplier-verification/`,
		method: "GET",
		params,
		signal,
	})
}

export const getApiV1PaymentSupplierVerificationRetrieveQueryKey = (
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
) => {
	return [
		`/api/v1/payment/${id}/supplier-verification/`,
		...(params ? [params] : []),
	] as const
}

export const getApiV1PaymentSupplierVerificationRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
	},
) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1PaymentSupplierVerificationRetrieveQueryKey(id, params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>>
	> = ({ signal }) =>
		apiV1PaymentSupplierVerificationRetrieve(id, params, signal)

	return {
		queryKey,
		queryFn,
		enabled: !!id,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1PaymentSupplierVerificationRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>>
>
export type ApiV1PaymentSupplierVerificationRetrieveQueryError = unknown

export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params: undefined | ApiV1PaymentSupplierVerificationRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>
				>,
				"initialData"
			>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1PaymentSupplierVerificationRetrieveQueryOptions(
			id,
			params,
			options,
		)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * A method to accept or reject the payment for the EnergySupplier with optionally corrected payment entries
 */
export const apiV1PaymentSupplierVerificationCreate = (
	id: number,
	supplierVerification: SupplierVerification,
	signal?: AbortSignal,
) => {
	return apiWithTokenAuth<SupplierVerificationResponse>({
		url: `/api/v1/payment/${id}/supplier-verification/`,
		method: "POST",
		headers: { "Content-Type": "application/json" },
		data: supplierVerification,
		signal,
	})
}

export const getApiV1PaymentSupplierVerificationCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
		TError,
		{ id: number; data: SupplierVerification },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
	TError,
	{ id: number; data: SupplierVerification },
	TContext
> => {
	const mutationKey = ["apiV1PaymentSupplierVerificationCreate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
		{ id: number; data: SupplierVerification }
	> = (props) => {
		const { id, data } = props ?? {}

		return apiV1PaymentSupplierVerificationCreate(id, data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1PaymentSupplierVerificationCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>
>
export type ApiV1PaymentSupplierVerificationCreateMutationBody =
	SupplierVerification
export type ApiV1PaymentSupplierVerificationCreateMutationError = unknown

export const useApiV1PaymentSupplierVerificationCreate = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
		TError,
		{ id: number; data: SupplierVerification },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
	TError,
	{ id: number; data: SupplierVerification },
	TContext
> => {
	const mutationOptions =
		getApiV1PaymentSupplierVerificationCreateMutationOptions(options)

	return useMutation(mutationOptions)
}
export const apiV1ProductionCounterRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<void>({
		url: `/api/v1/production_counter/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ProductionCounterRetrieveQueryKey = () => {
	return [`/api/v1/production_counter/`] as const
}

export const getApiV1ProductionCounterRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiV1ProductionCounterRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
	> = ({ signal }) => apiV1ProductionCounterRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ProductionCounterRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
>
export type ApiV1ProductionCounterRetrieveQueryError = unknown

export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ProductionCounterRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * Get client profile data. To be used for populating screen C2.1.

# Response values
- `client`
    - `name`
    - `email`
    - `phone` (optional)
- `latest badge` The latest user badge that has been awarded to client.
- `projects` Overview of projects the user has invested in
    - `project` Project details
    - `solar_parts_owned` Number of solar parts owned by client in this project
    - `total_nominal_value` Total nominal value of solar parts owned
    - `generated_power` Total generated power by solar parts owned
    - `power_cost_ct_kWh` Current power cost rate
    - `return_on_investment` Return on investment over period
 */
export const apiV1ProfileRetrieve = (signal?: AbortSignal) => {
	return apiWithTokenAuth<UserProfile>({
		url: `/api/v1/profile/`,
		method: "GET",
		signal,
	})
}

export const getApiV1ProfileRetrieveQueryKey = () => {
	return [`/api/v1/profile/`] as const
}

export const getApiV1ProfileRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
			TError,
			TData
		>
	>
}) => {
	const { query: queryOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiV1ProfileRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
	> = ({ signal }) => apiV1ProfileRetrieve(signal)

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ProfileRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
>
export type ApiV1ProfileRetrieveQueryError = unknown

export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
			>,
			"initialData"
		>
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
				TError,
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
			>,
			"initialData"
		>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
			TError,
			TData
		>
	>
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ProfileRetrieveQueryOptions(options)

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>
	}

	query.queryKey = queryOptions.queryKey

	return query
}

/**
 * Update phone number for the authenticated user.
 */
export const apiV1ProfilePhonePartialUpdate = (
	patchedUserPhone: NonReadonly<PatchedUserPhone>,
) => {
	return apiWithTokenAuth<ApiV1ProfilePhonePartialUpdate200>({
		url: `/api/v1/profile/phone/`,
		method: "PATCH",
		headers: { "Content-Type": "application/json" },
		data: patchedUserPhone,
	})
}

export const getApiV1ProfilePhonePartialUpdateMutationOptions = <
	TError = ApiV1ProfilePhonePartialUpdate400,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
		TError,
		{ data: NonReadonly<PatchedUserPhone> },
		TContext
	>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
	TError,
	{ data: NonReadonly<PatchedUserPhone> },
	TContext
> => {
	const mutationKey = ["apiV1ProfilePhonePartialUpdate"]
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
		{ data: NonReadonly<PatchedUserPhone> }
	> = (props) => {
		const { data } = props ?? {}

		return apiV1ProfilePhonePartialUpdate(data)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1ProfilePhonePartialUpdateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>
>
export type ApiV1ProfilePhonePartialUpdateMutationBody =
	NonReadonly<PatchedUserPhone>
export type ApiV1ProfilePhonePartialUpdateMutationError =
	ApiV1ProfilePhonePartialUpdate400

export const useApiV1ProfilePhonePartialUpdate = <
	TError = ApiV1ProfilePhonePartialUpdate400,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
		TError,
		{ data: NonReadonly<PatchedUserPhone> },
		TContext
	>
}): UseMutationResult<
	Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
	TError,
	{ data: NonReadonly<PatchedUserPhone> },
	TContext
> => {
	const mutationOptions =
		getApiV1ProfilePhonePartialUpdateMutationOptions(options)

	return useMutation(mutationOptions)
}
